
import { Component, EventEmitter, Inject, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/shared/services/apiService.service';
import { ToastrService } from 'ngx-toastr';
import { RegexService } from 'src/app/shared/form-validation/regex.service';
import { FormErrorService } from 'src/app/shared/form-validation/form-error.service';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { RootService } from 'src/app/shared/services/root.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { secureStorage } from 'src/app/shared/services/encryption/secureservice';
import { isPlatformBrowser } from '@angular/common';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['../profile/profile.component.scss']
})
export class UserProfileComponent implements OnInit {
  profileFormGroup!: FormGroup;
  sub: Subscription = new Subscription
  stateList: any;
  districtList: any = [];
  userData: any;
  isAllowToEdit: boolean = false;
  showEmailError: boolean = false;
  email: any;
  page: null;
  selectedAddressProof: any = null;
  selectedIDProof: any = null;
  environment1 = environment.s3bucket.url;
  kycAddOne: any;
  kycAddrTwo: any;
  kycAddr: any;
  kycKarzaRes: any;
  selectedIdDocNo: any = '';
  selectedAddDocNo: any = '';
  userKYCDetails: any;
  isIdKYCDone: boolean = false;
  isAddKYCDone: boolean = false;
  isPanVerified: boolean = false;
  isAdhaarVerified: boolean = false;
  isAdhaarNoAvailable: any;
  panTypeOptions = [
    { label: 'Individual', value: 'Individual' }
    // { label: 'Company (including Partnership, Trust, Society, School, Hospital etc.)', value: 'Company' }
  ];
  panNoAvailable: string;
  
  constructor(private toastrService: ToastrService, private apiService: ApiService, private behaviorService: BehaviourSubjectService, 
    private fb: FormBuilder, private regexService: RegexService, private router: Router, private secureService: RootService,
    private spinner: NgxSpinnerService, private CommonService:CommonService,
    @Inject(PLATFORM_ID) private platformId: Object, private formErrorService: FormErrorService, private localStorage: secureStorage,) { }

  ngOnInit(): void {
    this.getUserDetails()
    this.resetFormGroup();
    this.selectedAddressProof = "aadhar_card"
    this.selectedIDProof = "id_pancard";

  }

  @Output() goBack: EventEmitter<void> = new EventEmitter<void>();
  mobileBack() {
    this.goBack.emit();
  }
  getUserDetails() {
    if (isPlatformBrowser(this.platformId)) {
    let res = this.secureService.isLoggedIn();
    if (res) {
      this.sub.add(this.apiService.getUserData().subscribe({
        next: (response: any) => {
          this.userData = response["data"];
          this.userKYCDetails = response["data"];
          if (this.userKYCDetails?.user_documents) {
            for (let i = 0; i < this.userKYCDetails.user_documents.length; i++) {
              if (this.userKYCDetails.user_documents[i].document_description == "aadhar_card") {
                this.isAdhaarNoAvailable = this.localStorage.decryptData(this.userKYCDetails.user_documents[i].doc_number)
                // this.bookingForm.controls['aadhar'].setValue(this.isAdhaarNoAvailable);
                // this.bookingForm.get("aadhar").updateValueAndValidity();
                // this.selectedAddressProof = this.userKYCDetails.user_documents[i].document_description
                // this.selectedAddDocNo = this.userKYCDetails.user_documents[i].doc_number
                this.isAdhaarVerified = this.userKYCDetails.user_documents[i].e_kyc
              }
              else {
                this.panNoAvailable = this.localStorage.decryptData(this.userKYCDetails.user_documents[i].doc_number);
                // this.bookingForm.controls['panNo'].setValue(panNo);
                // this.bookingForm.get("panNo").updateValueAndValidity();
                // this.selectedIDProof = this.userKYCDetails.user_documents[i].document_description
                // this.selectedIdDocNo = this.userKYCDetails.user_documents[i].doc_number
                this.isPanVerified = this.userKYCDetails.user_documents[i].e_kyc
              }
            }
          }
          this.bindUserProfile()
          // if (this.page == 'profilePage') {

            if (this.userData.state) {
              this.getState();
            }
          // }

          this.kycAddOne = this.userData?.address_one
          this.kycAddrTwo = this.userData?.address_two
          if (this.userData?.user_documents) {
            for (let i = 0; i < this.userData.user_documents.length; i++) {
              if (this.userData.user_documents[i].document_description == "aadhar_card" || this.userData.user_documents[i].document_description == "adhar_card") {
                this.selectedAddressProof = this.userData.user_documents[i].document_description
                this.selectedAddDocNo = this.localStorage.decryptData(this.userData.user_documents[i].doc_number)
                this.isAddKYCDone = this.userData.user_documents[i].e_kyc
              }
              else if (this.userData.user_documents[i].document_description == "id_pancard") {
                this.selectedIDProof = this.userData.user_documents[i].document_description
                this.selectedIdDocNo = this.localStorage.decryptData(this.userData.user_documents[i].doc_number)
                this.isIdKYCDone = this.userData.user_documents[i].e_kyc
              }
              else { }
            }
          }

        },
        error: () => {
        },
      })
      );
    } else {
      this.toastrService.warning('Kindly Login');
      this.router.navigate(['/login/']);
    }
  }
  }

  getPanType(): string {
    let pandata = this.panNoAvailable 
    
    if (pandata && pandata.length === 10) {
      return pandata[3] === 'P' ? 'Individual' : this.userData?.account_type;
    } 
    
    return this.userData?.account_type || ''; // Default to userData's account_type if available
  }

  updateUserAddress() {
    var userAddrss = this.kycKarzaRes?.address
    this.kycAddr = userAddrss.buildingName + ',' + userAddrss.locality + ',' + userAddrss.streetName + ',' +
      userAddrss.city + '-' + userAddrss.pinCode
    this.kycAddOne = this.kycAddr.substring(0, 59),
      this.kycAddrTwo = this.kycAddr.substring(59, 119)
    let data = {
      "id": this.userData.id,
      "first_name": this.CommonService.replaceUnicode(this.userData.first_name),
      "last_name": this.CommonService.replaceUnicode(this.userData.last_name),
      "email_id": this.userData.email_id,
      "address_one": this.kycAddr.substring(0, 59),
      "address_two": this.kycAddr.substring(59, 119),
      "account_type": this.profileFormGroup.value.pan_type,

    }
    try {
      this.sub.add(this.apiService.updateCustomer(data).subscribe({
        next: (res: any) => {
          if (res.success) {
            this.toastrService.success(res.data.msg);
            this.getUserDetails()
            this.spinner.hide()
          }
          else {
            this.toastrService.warning(res.data.msg)
            this.spinner.hide()

          }
        },
        error: () => {
          this.spinner.hide()
        },
      }))
    } catch (error) {
      this.spinner.hide();
    }
  }

  nameErrors: { [key: string]: boolean } = {
    firstName: false,
    lastName: false,
  };

  validateName(event: any, fieldName: string) {
    let inputValue = event.target.value;
    const regex = /^[a-zA-Z\s]*$/;
    if (!regex.test(inputValue)) {
      this.nameErrors[fieldName] = true;
    } else {
      this.nameErrors[fieldName] = false;
    }
    inputValue = inputValue.replace(/[^a-zA-Z\s]/g, '');
    event.target.value = inputValue;
    this.profileFormGroup.controls[fieldName]?.setValue(inputValue, {
      emitEvent: false,
    });
  }

  checkNameError(fieldName: string) {
    const fieldValue = this.profileFormGroup.controls[fieldName]?.value;
    this.nameErrors[fieldName] = /[^a-zA-Z\s]/.test(fieldValue);
  }

  submitKYCDetails() {
    if (!this.selectedAddressProof && !this.selectedIDProof) {
      this.toastrService.warning("Select proof type from Address and ID proof and Enter Document No.");
      return;
    } else {
      if (this.selectedAddressProof && this.selectedAddDocNo == '') {
        this.toastrService.warning("Insert Address Proof Document No.");
        return;
      }
      else if (!this.selectedAddressProof && this.selectedAddDocNo != '') {
        this.toastrService.warning("Select Address Document Type");
        return;
      }

      if (this.selectedIDProof && this.selectedIdDocNo == '') {
        this.toastrService.warning("Insert ID Proof Document No.");
        return;
      } else if (!this.selectedIDProof && this.selectedIdDocNo != '') {
        this.toastrService.warning("Select ID Document Type");
        return;
      }
    }

    if (this.selectedIDProof == 'id_pancard') {
      var pan = this.selectedIdDocNo.match(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/)
      if (pan == null) {
        this.toastrService.warning('Invalid format of Pan Number')
        return;
      }
    }
    var kfcJson = {
      "pan": this.selectedIdDocNo,
      "aadhaarLastFour": this.selectedAddDocNo.substr(this.selectedAddDocNo.length - 4),
      "dob": "",
      "name": "",
      "address": "",
      "getContactDetails": "N",
      "PANStatus": "Y",
      "isSalaried": "N",
      "isDirector": "N",
      "isSoleProp": "N",
      "fathersName": "N",
      "consent": "Y",
      "clientData": {
        "caseId": "123456"
      }
    }
    this.spinner.show()
    try {
      this.sub.add(this.apiService.checkkyc(kfcJson).subscribe({
        next: (res: any) => {
          if (res.success) {
            if (res.data.result) {
              this.kycKarzaRes = res.data.result;
              if (Object.keys(res.data.result).length !== 0) {
                if (res.data.result?.aadhaarMatch == true) {
                  if (this.profileFormGroup.value.first_name.toLowerCase() === res.data.result?.firstName.toLowerCase()) {
                    this.uploadKfc()
                    this.toastrService.success("KYC Done Successfully")
                  }
                  else {
                    this.spinner.hide()
                    this.toastrService.warning("Name Not Matching With Pan Card")
                    return
                  }
                }
                else {
                  this.spinner.hide()
                  this.toastrService.warning("Aadhaar number is incorrect.")
                  return
                }
              }
              else {
                this.spinner.hide()
                this.toastrService.warning("Aadhaar number or PAN number is incorrect.")
                return
              }
            }
          }
          else {
            this.spinner.hide()
            this.toastrService.warning(res.data.msg)
          }
        },
        error: () => {
          this.spinner.hide()
        }
      }))
    } catch (error) {
      this.spinner.hide();
    }
  }
  uploadKfc() {
    let req = {
      "address_proofs": this.isAddKYCDone == false ? [
        {
          "data": "",
          "document_type": "Address Proof",
          "document_description": this.selectedAddressProof,
          "doc_number": this.selectedAddDocNo,
          "e-KYC": true
        }
      ] : [],
      "id_proofs": this.isIdKYCDone == false ? [
        {
          "data": "",
          "document_type": "ID Proof",
          "document_description": this.selectedIDProof,
          "doc_number": this.selectedIdDocNo,
          "e-KYC": true
        }
      ] : []
    }
    try {
      this.sub.add(this.apiService.uploadKYC(req).subscribe({
        next: (res: any) => {

          if (res.success) {
            // this.toastrService.success(res.data.msg)

            // // if(res.data.id_proofs.e_kyc == true){
            // //   this.isKYCDone == true
            // // }
            this.updateUserAddress()
          }
          else {
            this.spinner.hide()
            this.toastrService.warning(res.data.msg)
          }
          // this.isShowThankyouPage = true
        },
        error: () => {
          this.spinner.hide()
        },
        complete: () => {
          this.spinner.hide()
        }
      }))
    } catch (error) {
      this.spinner.hide();
    }
  }
  resetFormGroup() {
    this.profileFormGroup = this.fb.group({
      mobile_number: [""],
      first_name: [""],
      last_name: [""],
      email_id: ["", [Validators.required, Validators.pattern(/^\w+([\.]?\w+)*@\w+([\.]?\w+)*(\.\w{2,3})+$/)]],
      // location: ["", Validators.required],
      address: ["", Validators.required],
      state: ["", Validators.required],
      district: ["", Validators.required],
      pan_type: ['Individual', Validators.required],
      full_name: ["", ],
    })
    this.profileFormGroup.get('pan_type')?.valueChanges.subscribe(value => {
      console.log('3333333333333',this.profileFormGroup.controls['pan_type'].value)
      this.updateFirstNameValidation(value);
    });
  }

  // onFocusOutRemoveSpace(event:any){
  //   let value=(event.target.value).replace(/\s/g, "")
  //   this.profileFormGroup.patchValue({last_name:value})
  // }
  // onFocusOutRemoveSpacefirst_name(event:any){
  //   let value=(event.target.value).replace(/\s/g, "")
  //   this.profileFormGroup.patchValue({first_name:value})
  // }

  getState() {
    let data = {
      // lob: this.lob
    }
    this.sub.add(this.apiService.getStateList(data).subscribe({
      next: (res: any) => {
        this.stateList = res;
        if (!this.isAllowToEdit) {
          if (this.userData.state) {
            this.profileFormGroup.patchValue({ state: this.userData.state })
            this.getDistrictList();
          }
        }
        else {
          if (this.userData.state) {
            this.getDistrictList();
          }

        }
      }
    }))
  }

  getDistrictList(item?) {
    this.districtList = [];
    let statecode;
    let state = this.profileFormGroup.value.state;
    this.stateList?.forEach((e: any) => {
      if (e.name == state) {
        statecode = e.code;
      }
    });

    let dummyList = {};
    dummyList = {
      code: statecode,
      state: state,
    };

    let stateData = {
      state: dummyList,
      // lob: this.lob,
    };

    this.sub.add(this.apiService.getDistrictList(stateData).subscribe({
      next: (response: any) => {
        this.districtList = response;
        if (this.userData.district && !item) {
          this.userData.district=this.userData.district.toUpperCase();
          this.profileFormGroup.patchValue({ district:this.userData.district})
        }
        if (item) {
          this.profileFormGroup.patchValue({ district: "" })
        }
      },
      error: () => {
      },
      complete: () => {
        if (!item) {
          this.bindUserProfile();
        }
      }
    })
    );
  }

  bindUserProfile() {
    let state;
    this.stateList?.forEach((e: any) => {
      if (e.name == this.userData.state) {
        this.profileFormGroup.controls['state'].setValue(e.name);
        state = e
      }
    })

    if (this.userData.district) {
      this.profileFormGroup.patchValue({ district: this.userData.district })
    }

    const firstName = this.CommonService.replaceUnicode(this.userData.first_name) || '';
    const lastName = this.CommonService.replaceUnicode(this.userData.last_name) == '.' ? '' : this.CommonService.replaceUnicode(this.userData.last_name) || '';
    const fullName = `${firstName} ${lastName}`.trim(); // Concatenating first & last name


    this.profileFormGroup?.patchValue({
      first_name: this.CommonService.replaceUnicode(this.userData.first_name),
      last_name:this.CommonService.replaceUnicode(this.userData.last_name) == '.' ? '' : this.CommonService.replaceUnicode(this.userData.last_name) || '',
      email_id: this.userData.email_id,
      state: state ? state.name : '',
      mobile_number: this.userData.mobile_number,
      district: this.userData.district ? this.userData.district : '',
      address: this.userData.address_one ? this.userData.address_one : '',
      pan_type:'Individual',
      full_name: fullName
    }
    )
  }

  clickToEdit(Cancel?) {
    this.isAllowToEdit = !this.isAllowToEdit;
    if (Cancel) {
      this.showEmailError = false;
      if (this.userData.state) {
        this.profileFormGroup.patchValue({ state: this.userData.state })
      }
      this.getDistrictList();

      this.bindUserProfile();
    }
    if (this.userData.state) {
      // this.getState();

    }
    else {
      this.getState();
    }
  }
  companyNameError: boolean = false;

  validateCompanyName(event: any) {
    let inputValue = event.target.value;
    const restrictedChars = /[<>{}|~^*]/;
  
    if (restrictedChars.test(inputValue)) {
      this.companyNameError = true;
    } else {
      this.companyNameError = false;
    }
  
    inputValue = inputValue.replace(/[<>{}|~^*]/g, '');
    event.target.value = inputValue;
  
    this.profileFormGroup.controls['full_name'].setValue(inputValue, { emitEvent: false });
  }
  checkCompanyNameError() {
    const fieldValue = this.profileFormGroup.controls['full_name'].value;
    this.companyNameError = /[<>{}|~^*]/.test(fieldValue);
  }
  

  save() {
    const controls = this.profileFormGroup.controls;

    // Run name field validations manually if Individual
    if (this.profileFormGroup.get('pan_type')?.value === 'Individual') {
      const nameFields = ['first_name', 'last_name'];
      nameFields.forEach(field => {
        const value = controls[field]?.value || '';
        const cleaned = value.replace(/[^a-zA-Z\s]/g, '');
        controls[field].setValue(cleaned, { emitEvent: false });
  
        const isValid = /^[a-zA-Z\s]*$/.test(cleaned);
        this.nameErrors[field === 'first_name' ? 'firstName' : 'lastName'] = !isValid;
      });
    }
  
    // Scroll to first invalid field if any
    if (this.profileFormGroup.invalid) {
      const firstInvalidControl = Object.keys(controls).find(key => controls[key].invalid);
      if (firstInvalidControl) {
        const invalidElement = document.getElementsByName(firstInvalidControl)[0];
        if (invalidElement) {
          invalidElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          (invalidElement as HTMLElement).focus();
        }
      }
  
      this.profileFormGroup.markAllAsTouched();
  
      if (this.showEmailError && this.profileFormGroup.value.email_id?.length > 0) {
        this.toastrService.warning('Please add valid email id');
      } else {
        this.toastrService.warning('Please add all mandatory fields');
      }
      return;
    }
  
    // Reset error states if valid
    this.nameErrors['first_name'] = false;
    this.nameErrors['lastName'] = false;
  
    // Construct API payload
    const data: any = {
      id: this.userData.id,
      last_name: this.profileFormGroup.value.pan_type === 'Individual'
        ? this.CommonService.replaceUnicode(this.profileFormGroup.value.last_name)
        : '.',
      email_id: this.profileFormGroup.value.email_id,
      state: this.profileFormGroup.value.state,
      district: this.profileFormGroup.value.district,
      address_one: this.profileFormGroup.value.address,
      account_type: this.profileFormGroup.value.pan_type,
    };
  
    if (this.profileFormGroup.value.pan_type === 'Individual') {
      data['first_name'] = this.CommonService.replaceUnicode(this.profileFormGroup.value.first_name);
    } else {
      data['first_name'] = this.CommonService.replaceUnicode(this.profileFormGroup.value.full_name);
    }
      
    this.sub.add(this.apiService.updateCustomer(data).subscribe({
      next: (res: any) => {
        if (res.success) {
          this.userData = res.data.data;
          this.secureService.setUser(res.data.data);
          this.toastrService.success(res.data.msg);
          this.isAllowToEdit = false;
          this.bindUserProfile()
          this.behaviorService.isLoggedIn.next(true);
        }
        else {
          this.toastrService.warning(res.data.msg)

        }
      }
    }))
  }
  public hasRequiredError = (controlName: string): boolean | undefined =>
    this.formErrorService.hasRequiredError(controlName, this.profileFormGroup);
  public hasPatternError = (controlName: string): boolean | undefined =>
    this.formErrorService.hasPatternError(controlName, this.profileFormGroup);


    alphanumbericOnlyFirstLastName(event: any): boolean {
      var inp = String.fromCharCode(event.keyCode);
      if (/[a-zA-Z]|[.]|[ ]/.test(inp)) {
        return true;
      } else {
        event.preventDefault();
        return false;
      }
    }

    notAllowSpace(event: any) {
      if ((event.target.selectionStart === 0 && event.which === 32) || event.key === '.') {
        event.preventDefault();
      }
    }
    nAllowSpace(event: KeyboardEvent) {
      if (event.key === ' ') {
        event.preventDefault();
      }
    }
    emailValidator(event) {
      this.showEmailError = false;
      this.email = event.target.value;
      var validRegex = '^.+@.+\\..+$';

      if (this.email.match(validRegex)) {
        this.showEmailError = false;
      }
      else {
        this.showEmailError = true;
      }
      if (this.email.length == 0) {
        this.showEmailError = false;
      }
    }
    sanitizeInput(input: string): string {
      // Remove HTML tags
      return input.replace(/<\/?[^>]+(>|$)/g, '');
    }
    get f() {
    return this.profileFormGroup.controls;
   }
    // Usage in the HTML
    onInput(event: any): void {
      const inputElement = event.target as HTMLInputElement;
      inputElement.value = this.sanitizeInput(inputElement.value);
    }
    getAccountType(data:any){
      console.log(data.target.value);

    }
    updateFirstNameValidation(accountType: string) {
      const firstNameControl = this.profileFormGroup.get('first_name');
      const lastNameControl = this.profileFormGroup.get('last_name');
      const full_nameControl = this.profileFormGroup.get('full_name');
    
      if (accountType === 'Individual') {
        firstNameControl?.setValidators([
          Validators.required,
          this.individualNameValidator
        ]);
        lastNameControl?.setValidators([
          Validators.required,
          this.individualNameValidator
        ]);
        full_nameControl?.setValidators([]);
      } else if (accountType === 'Company') {
        full_nameControl?.setValidators([Validators.required,
          this.companyNameValidator]);
        firstNameControl?.setValidators([
          
        ]);
        lastNameControl?.setValidators([
        ]);
      }
    
      firstNameControl?.updateValueAndValidity();
      lastNameControl?.updateValueAndValidity();
      full_nameControl?.updateValueAndValidity();
    }
    
    // Validator for Individual Names (Only Alphabets and Spaces)
    individualNameValidator(control: AbstractControl) {
      const nameRegex = /^[A-Za-z\s]+$/; // Only letters and spaces
      if (control.value && !nameRegex.test(control.value)) {
        return { invalidIndividualName: true };
      }
      return null;
    }

    // Validator for Company Names (Allow all except < > { } | ~ ^ *)
    companyNameValidator(control: AbstractControl) {
      const restrictedChars = /[<>{}|~^*]/; // Restricted special characters
      if (control.value && restrictedChars.test(control.value)) {
        return { invalidCompanyName: true };
      }
      return null;
    }
    hasError(controlName: string, errorType: string) {
      return this.profileFormGroup.get(controlName)?.hasError(errorType) && this.profileFormGroup.get(controlName)?.touched;
    }


}
